import React, { useEffect } from "react";
import { myComponentProps } from "./EndSessionModal";
import ReuseModal from "../../../../../components/fragment/modal/ReuseModal";
import "../../../../../styles/dashboard/setting/modals/SetupMFAModal.css";
import { BsCopy, BsCheckLg } from "react-icons/bs";
import { ColorRing } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../../../redux/type";
import { get2FASetup } from "../../../../../redux/settings";

interface setUpMFAModalProp extends myComponentProps {
  onSuccess: () => void;
}

export default function SetupMFAModal({
  onClose,
  visible,
  onSuccess,
}: setUpMFAModalProp) {
  const dispatch = useDispatch();
  const { setup_mfa, loading_mfa } = useSelector(
    (state: RootState) => state.settings
  );
  const [copied, setCopied] = React.useState(false);

  useEffect(() => {
    if (visible) {
      dispatch(get2FASetup({} as any) as any);
    }
  }, [dispatch, visible]);

  const copyText = async (textToCopy: string) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <ReuseModal
      visible={visible}
      onClose={onClose}
      hideCancel
      hideBtn
      btnLabel="Continue"
      title="Set up 2FA"
      classname="modal-expansion"
    >
      <main className="setup-mfa-modal-container">
        <h4 className="main-header">Enable authenticator app</h4>
        <p className="sub-header">
          To enable 2FA, you will have to install an authenticator app on your
          device, either goggle auth or any other secure app
        </p>

        <article className="overlay-bg">
          {loading_mfa ? (
            <>
              {/* <NoContentPage loading={true} /> */}
              <ColorRing
                visible={true}
                height="50"
                width="50"
                ariaLabel="color-ring-loading"
                wrapperStyle={{}}
                wrapperClass="color-ring-wrapper"
                colors={[
                  "rgba(115, 71, 146, 1)",
                  "rgba(115, 71, 146, 1)",
                  "rgba(115, 71, 146, 1)",
                  "rgba(115, 71, 146, 1)",
                  "rgba(115, 71, 146, 1)",
                ]}
              />
            </>
          ) : (
            <>
              <figure className="qr-code">
                <img src={setup_mfa?.google2fa_url} alt="qr code mfa" />
              </figure>
              <div className="qr-description">
                <p className="desc-header">
                  Scan QR code above for the auth app
                </p>
                <p className="desc-body">
                  Having issues scanning QR code? Configure your app with this
                  key.
                </p>
              </div>
              <figure className="qr-url">
                <p className="qr-text">{setup_mfa?.secret}</p>
                <span
                  className="qr-check"
                  onClick={() => copyText(setup_mfa?.secret)}
                >
                  {copied ? <BsCheckLg /> : <BsCopy />}
                </span>
                {/* <BsCheckLg/> */}
              </figure>
            </>
          )}
        </article>
        <div className="btn-group">
          <button className="bt-general danger-color" onClick={onClose}>
            Cancel
          </button>
          <button
            disabled={loading_mfa}
            className="bt-general pry-btn-color"
            onClick={onSuccess}
          >
            Continue
          </button>
        </div>
      </main>
    </ReuseModal>
  );
}
